import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Loading from "../../Components/Loading/Loading";
import ShowCard from "../../Components/ShowCard/ShowCard";
import GaiaCard from "../../Components/ShowCard/GaiaCard";
import { ToastContainer, toast } from "react-toastify";
import { useWindowWidth } from "@react-hook/window-size";
import Translate from "../../Components/Multilanguage/Translate";

import { rowItemCount } from "../../utils/utils";
import * as service from "../MyList/service";

const PlaylistPage = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const isRTL = useSelector((state) => state?.rtl?.isRTL);
  const myListRedux = useSelector((state) => state?.myList?.value);
  const [shows, setShows] = useState([]);
  const [playlistTitle, setPlaylistTitle] = useState("");
  const [loading, setLoading] = useState(true);
  const [thumbnailOrientation, setThumbnailOrientation] = useState("");
  const [rowItemsClass, setRowItemsClass] = useState("");
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;
  const pubid = projectInfo?.projectConfig?.pubid || projectInfo?.pubid;
  const isYowTv = pubid == 50187 || Number(pubid) === 50187;

  const location = useLocation();
  const navigate = useNavigate();
  const { playlistId } = useParams();
  const windowSize = useWindowWidth();

  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };

  useEffect(() => {
    if (
      projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION === "PORTRAIT"
    ) {
      setThumbnailOrientation("PORTRAIT");
    } else {
      setThumbnailOrientation("LANDSCAPE");
    }
  }, [projectInfo]);

  useEffect(() => {
    if (windowSize > 980) {
      if (isYowTv) {
        setRowItemsClass("rowCount6");
      } else if (projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT) {
        setRowItemsClass(rowItemCount(projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT));
      } else {
        setRowItemsClass("rowCount4");
      }
    } else {
      setRowItemsClass("");
    }
  }, [projectInfo, windowSize, isYowTv]);

  useEffect(() => {
    window.scroll(0, 0);
    if (location?.state?.shows) {
      setShows(location.state.shows);
      if (location.state.category_name) {
        setPlaylistTitle(location.state.category_name);
      }
      setLoading(false);
    }
  }, [location?.state]);

  useEffect(() => {
    // Always fetch fresh data from API
    fetchPlaylistData();
  }, [playlistId]);

  const fetchPlaylistData = async () => {
    try {
      const response = await service.fetchWatchlistShows(appInfo);
      if (response?.status === 200) {
        const playlists = response?.data?.data;
        if (Array.isArray(playlists)) {
          const currentPlaylist = playlists.find(
            (playlist) => Number(playlist.playlist_id) === Number(playlistId)
          );

          if (currentPlaylist) {
            setShows(currentPlaylist.shows || []);
            setPlaylistTitle(currentPlaylist.title || "");
            setLoading(false);
          } else {
            // Playlist not found, redirect to my list
            navigate("/my-list");
          }
        } else {
          setLoading(false);
        }
      }
    } catch (err) {
      setLoading(false);
      toast.error(err?.response?.data?.message || "Error loading playlist", {
        position: "bottom-center",
      });
      navigate("/my-list");
    }
  };

  // Sync with Redux myList updates to reflect removed items
  useEffect(() => {
    if (myListRedux && playlistId && Array.isArray(myListRedux)) {
      const currentPlaylist = myListRedux.find(
        (playlist) => Number(playlist.playlist_id) === Number(playlistId)
      );
      if (currentPlaylist) {
        setShows(currentPlaylist.shows || []);
        if (currentPlaylist.title) {
          setPlaylistTitle(currentPlaylist.title);
        }
      }
    }
  }, [myListRedux, playlistId]);

  if (loading) {
    return <Loading />;
  }

  return (
    <div className={`myList ${isRTL ? "rtl" : ""} ${isYowTv ? "yowtv-my-list" : ""}`}>
      <ToastContainer />

      <div className="wrapper">
        <div className="top">
          <h1 className={`heading ${template === "TEMPLATE_10" ? "gaia" : ""}`}>
            {playlistTitle || <Translate textKey={"my_list"} />}
          </h1>
        </div>
        <div className="bottom">
          <div className="itemsContainer">
            {shows?.map((item, index) => (
              <div
                key={index}
                className={
                  thumbnailOrientation === `PORTRAIT`
                    ? `items portrait ${rowItemsClass}`
                    : `items landscape ${rowItemsClass}`
                }
              >
                {template === "TEMPLATE_10" || isYowTv ? (
                  <GaiaCard
                    data={item}
                    imageUrl={true}
                    season={false}
                    metaData={true}
                    modalNavigation={true}
                    showMyListButton={true}
                    fromFavoritesScreen={true}
                    playlistId={playlistId}
                    thumbnailOrientation={thumbnailOrientation}
                  />
                ) : (
                  <ShowCard
                    data={item}
                    imageUrl={true}
                    season={false}
                    metaData={true}
                    modalNavigation={true}
                    showMyListButton={true}
                    fromFavoritesScreen={true}
                    playlistId={playlistId}
                    thumbnailOrientation={thumbnailOrientation}
                  />
                )}
              </div>
            ))}
          </div>
          {shows?.length === 0 && (
            <div className="favourite-empty-state">
              <h2>
                <Translate textKey="no_data_found" />
              </h2>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PlaylistPage;
